<template>
  <div id="app-wrapper">
    <router-view />
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import { initSessionCheck } from './utils/sessionManager';

export default {
  name: 'App',
  setup() {
    let checkInterval;

    onMounted(() => {
      checkInterval = initSessionCheck();
    });

    onUnmounted(() => {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
    });
  }
};
</script>

<style>
/* Remove global overflow restrictions */
body, html {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
}

/* Target performance card specifically */
.performance-card,
.performance-card * {
  transform: none !important;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease !important;
}

.performance-card:hover,
.performance-card *:hover {
  transform: none !important;
}

/* Retain mobile-specific styles if needed */
@media (max-width: 768px) {
  body, html, #app {
    height: auto;
    min-height: 100vh;
  }
}
</style>
